<template lang="pug">
    div
        v-container
            v-breadcrumbs(large :items="itemsBreadcrum" divider=">")
                // ^- poner esto despues en un componente + store
            v-card(pa-3 raised)
                v-container
                    v-select(:items="itemsSelectMov"
                        ref="selectMov"
                        label="Seleccionar movimiento"
                        v-model="optionSelected"
                        @blur="mixKeepFocusByRef('selectMov', !optionSelected)"
                        @input="changeMovement(optionSelected)")
                v-divider
                form-cash-movement(
                    v-bind:typeMovement="optionSelected"
                    v-if="optionSelected"
                    @clearform="optionSelected = false")
            
</template>

<script>
//import Menu from '@/components/Menu/Menu'
import ActionsMenu from '@/components/ActionsMenu/ActionsMenu'
import InputValidations from '@/mixins/InputValidations.js'
import FormCashMovement from '@/components/CashMovement/FormCashMovement'
import Colors from '@/mixins/Colors.js'
import JSUtils from '@/mixins/reusable_mixins/JSUtils'
import { mapActions, mapState } from 'vuex'
import cashDeskOpenLeaveGuard from '@/mixins/cashDeskOpenLeaveGuard'
import cashDeskMustCloseCashGuard from '@/mixins/cashDeskMustCloseCashGuard'

export default {
    name: 'cash-movement',
    props: {},
    data: function() {
        return {
            optionSelected: false,
            itemsBreadcrum: [
                { text: 'Menú', disabled: false, href: '' },
                { text: 'Caja', disabled: false, href: '/' },
                { text: 'Movimiento Caja', disabled: true, href: '' },
            ],
            itemsSelectMov: [
                { id: 1, text: 'Apertura de caja', value: 'apertura' },
                { id: 2, text: 'Ingreso de caja', value: 'ingreso' },
                { id: 3, text: 'Egreso de caja', value: 'egreso' },
            ],
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            showSnackbar: 'showSnackbar',
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        ...mapActions('CashMovementModule', {
            setTypeMovement: 'setTypeMovement',
            setMovement: 'setMovement',
            setReason: 'setReason',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('UniqueKeyModule', {
            setPermission: 'setPermission',
        }),
        ...mapActions('AuthModule', ['fetchCasDeskStatus']),

        changeMovement(optionSelected) {
            for (let i = 0; i < 3; i++) {
                if (this.itemsSelectMov[i].value === optionSelected) {
                    this.setTypeMovement(this.itemsSelectMov[i].text)
                    this.setMovement(optionSelected)
                    let permission = ''
                    switch (optionSelected) {
                        case 'apertura':
                            permission = this.mixAuthCodePermissions
                                .AUTHORIZE_OPEN_CASH_DESK
                            break
                        case 'ingreso':
                            permission = this.mixAuthCodePermissions
                                .AUTHORIZE_INGRESS_CASH_DESK
                            break
                        case 'egreso':
                            permission = this.mixAuthCodePermissions
                                .AUTHORIZE_EGRESS_CASH_DESK
                            break
                    }
                    this.setPermission(permission)
                    return
                }
            }
        },
    },
    components: { FormCashMovement, ActionsMenu },
    mixins: [
        InputValidations,
        Colors,
        JSUtils,
        cashDeskOpenLeaveGuard,
        cashDeskMustCloseCashGuard,
    ],
    mounted() {
        this._$checkCashDeskStatus()
            .then(
                r =>
                    r
                        ? this._$checkMustCloseStatus()
                              .then(console.log)
                              .catch(console.log)
                        : ''
            )
            .catch(console.log)
        this.mixFocusByRef('selectMov')
    },
    filters: {},
}
</script>

<style lang="scss">
</style>
